import { Route } from '@angular/router';
import {
  AuthGuard,
  CountriesResolver,
  LanguagesResolver,
  TimezonesResolver,
} from '@ubie/core';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'installations',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'registration',
    resolve: { countries: CountriesResolver, languages: LanguagesResolver },
    loadComponent: () =>
      import('./login/registration/registration.page').then(
        (m) => m.RegistrationPage,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./login/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'dashboard',
    redirectTo: 'installations',
    pathMatch: 'full',
  },
  // dashboard route kept for future use
  // {
  //   path: 'dashboard',
  //   canActivate: [AuthGuard],
  //   data: {
  //     claimType: ['CanAccessDashboardManaged', 'CanAccessAdminDashboardAll'],
  //   },
  //   loadComponent: () =>
  //     import('./dashboard/dashboard.page').then((m) => m.DashboardPage),
  // },
  {
    path: 'account',
    canActivate: [AuthGuard],
    data: { claimType: ['CanUpdateAccountOwned', 'CanAccessAccountOwned'] },
    resolve: { countries: CountriesResolver, languages: LanguagesResolver },
    loadComponent: () =>
      import('./account/account-info/account-info.page').then(
        (m) => m.AccountInfoPage,
      ),
  },
  {
    path: 'activation/:activationKey',
    loadComponent: () =>
      import('./activation/activation.page').then((m) => m.ActivationPage),
  },
  {
    path: 'purchases',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessAccountOwned'] },
    loadComponent: () =>
      import('./account/purchases/purchases.page').then((m) => m.PurchasesPage),
  },
  {
    path: 'password',
    canActivate: [AuthGuard],
    data: { claimType: ['CanUpdateAccountOwned'] },
    loadComponent: () =>
      import('./account/password/password.page').then((m) => m.PasswordPage),
  },
  {
    path: 'installations',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsManaged', 'CanAccessInstallationsAll'],
    },
    loadComponent: () =>
      import('./installations/installations/installations.page').then(
        (m) => m.InstallationsPage,
      ),
  },
  {
    path: 'installation/:installationId/detail',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { countries: CountriesResolver, timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-detail/installation-detail.page'
      ).then((m) => m.InstallationDetailPage),
  },
  {
    path: 'installation/:installationId/devices',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-devices/installation-devices.page'
      ).then((m) => m.InstallationDevicesPage),
  },
  {
    path: 'installation/:installationId/owner',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { languages: LanguagesResolver },
    loadComponent: () =>
      import('./installations/installation-owner/installation-owner.page').then(
        (m) => m.InstallationOwnerPage,
      ),
  },
  {
    path: 'installation/:installationId/license',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { countries: CountriesResolver, timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-license/installation-license.page'
      ).then((m) => m.InstallationLicensePage),
  },
  {
    path: 'installation/:installationId/installers',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    loadComponent: () =>
      import(
        './installations/installation-installer/installation-installer.page'
      ).then((m) => m.InstallationInstallerPage),
  },
  {
    path: 'installation-add',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAddInstallationAll', 'CanAddInstallationManaged'],
    },
    resolve: { countries: CountriesResolver, timezones: TimezonesResolver },
    loadComponent: () =>
      import('./installations/installation-add/installation-add.page').then(
        (m) => m.InstallationAddPage,
      ),
  },
  {
    path: 'installation/:installationId/device/:deviceId',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },

    loadComponent: () =>
      import(
        './installations/installation-device/installation-device.page'
      ).then((m) => m.InstallationDevicePage),
  },
  {
    path: 'order/:orderNo/status',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessAccountOwned'] },
    loadComponent: () =>
      import('./order-status/order-status.page').then((p) => p.OrderStatusPage),
  },
  {
    path: 'installation/:installationId/accept/installer',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessDashboardManaged'] },
    loadComponent: () =>
      import(
        './installations/installation-accept/installation-accept.page'
      ).then((m) => m.InstallationAcceptPage),
  },
];
